"use client";
import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Grid, Popover, Descriptions } from "antd";
import AddPatientPopup from "../appointmentBooking/AddPatientPopUp";

const { useBreakpoint } = Grid;

const PatientInfo = ({ patient }) => {
  console.log("patients pass in patient info", patient);
  if (!patient) { return (  null ) }


  const screens = useBreakpoint();
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [editPatient, setEditPatient] = useState(false);
  const [patientDetail, setPatientDetail] = useState(patient?.patient || null);

useEffect(() => {
  if (patient?.patient ) {
    setPatientDetail(patient.patient );
  }
  else return null;
}, [patient]);

  // Responsive font size helper
  const getFontSize = (base, sm, xs) => {
    if (screens.xs) return xs;
    if (screens.sm) return sm;
    return base;
  };

  // Fields to ignore
  const excludedFields = [
    "id",
    "hospital_id",
    "office_id",
    "created_at",
    "updated_at",
    "flag",
    "group",
  ];

  // Prepare patient info for display
  const patientData = useMemo(() => {
    return Object.entries(patientDetail || {})
      .filter(([key, value]) => value && !excludedFields.includes(key))
      .map(([key, value]) => ({
        label: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase()), // make labels like "First Name"
        value: value.toString(),
      }));
  }, [patientDetail]);

  // Split info for 2-column layout
  const midIndex = Math.ceil(patientData.length / 2);
  const firstHalf = patientData.slice(0, midIndex);
  const secondHalf = patientData.slice(midIndex);

  // Modal close handler
  const handleClose = (data) => {
    console.log("updated data", data);
    setEditPatient(false);
    setPopoverVisible(false);
    if (data && Object.keys(data).length > 0) {
  setPatientDetail(data);

  
}

  };
const [isBlurActive, setIsBlurActive] = useState(false);

useEffect(() => {
  // Add or remove blur overlay dynamically
  const existingOverlay = document.getElementById("blur-overlay");

  if (popoverVisible) {
    if (!existingOverlay) {
      const overlay = document.createElement("div");
      overlay.id = "blur-overlay";
      Object.assign(overlay.style, {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        zIndex: 999, // below popover
        transition: "all 0.3s ease",
      });
      overlay.addEventListener("click", () => setPopoverVisible(false));
      document.body.appendChild(overlay);
    }
    setIsBlurActive(true);
  } else {
    if (existingOverlay) {
      existingOverlay.remove();
    }
    setIsBlurActive(false);
  }

  return () => {
    const cleanupOverlay = document.getElementById("blur-overlay");
    if (cleanupOverlay) cleanupOverlay.remove();
  };
}, [popoverVisible]);

const popoverContent = (
  <div
    style={{
      maxWidth: "850px",
      minWidth: "400px",
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
      padding: "20px",
      position: "relative",
      zIndex: 1000, // make sure it’s above the blur
    }}
  >
    <h3
      style={{
        textAlign: "center",
        fontSize: "18px",
        fontWeight: "700",
        color: "#1677ff",
        marginBottom: "16px",
      }}
    >
      Patient Details
    </h3>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: screens.xs ? "1fr" : "1fr 1fr",
        gap: "14px",
      }}
    >
      <Descriptions
        size="middle"
        bordered
        column={1}
        contentStyle={{ fontSize: "18px", fontWeight: 600, color: "#333" }}
        labelStyle={{
          fontWeight: "700",
          width: "40%",
          background: "#f9fafb",
          color: "#555",
          fontSize: "16px"
        }}
      >
        {firstHalf.map(({ label, value }) => (
          <Descriptions.Item key={label} label={label}>
            {value}
          </Descriptions.Item>
        ))}
      </Descriptions>

      <Descriptions
        size="middle"
        bordered
        column={1}
        contentStyle={{ fontSize: "18px", fontWeight: 600, color: "#333" }}
        labelStyle={{
          fontWeight: "700",
          width: "40%",
          background: "#f9fafb",
          color: "#555",
          fontSize: "16px"
        }}
      >
        {secondHalf.map(({ label, value }) => (
          <Descriptions.Item key={label} label={label}>
            {value}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>

    <div
      style={{
        textAlign: "right",
        marginTop: "18px",
        borderTop: "1px solid #e8e8e8",
        paddingTop: "10px",
      }}
    >
      <Button
        size="middle"
        type="primary"
        style={{
          fontWeight: "600",
          borderRadius: "8px",
          padding: "4px 16px",
        }}
        onClick={(e) => {
          e.stopPropagation();
          setPopoverVisible(false);
          setTimeout(() => setEditPatient(true), 100);
        }}
      >
        Edit
      </Button>
    </div>
  </div>
);


  return (
    <div
      className="patient-header p-1 h-100"
      style={{
        background: "#fff",
        overflow: "hidden",
      }}
    >
      <div className="h-100 d-flex flex-column justify-content-center">
        <table className="table-borderless w-100">
          <tbody>
            {/* Row 1 */}
            <tr className="align-middle">
              <td className="p-1">
                <Popover
                  content={popoverContent}
                  
                  trigger="click"
                  open={popoverVisible}
                  onOpenChange={setPopoverVisible}
                  placement="bottomLeft"
                  destroyTooltipOnHide // ✅ ensures safe cleanup
                >
                  <div
                    onClick={() => setPopoverVisible(!popoverVisible)}
                    style={{ cursor: "pointer" }}
                  >
                    <h4
                      className="m-0 text-truncate"
                      style={{
                        fontSize: getFontSize("20px", "18px", "16px"),
                        fontWeight: "600",
                        lineHeight: "1.2",
                        maxWidth: "100%",
                      }}
                    >
                      P-{patientDetail?.office_id} | {patientDetail?.full_name}
                    </h4>
                    <p
                      className="m-0 text-muted"
                      style={{
                        fontSize: getFontSize("14px", "13px", "12px"),
                      }}
                    >
                      {patientDetail?.gender} | {patientDetail?.age} | {patientDetail?.street}
                    </p>
                  </div>
                </Popover>
              </td>
            </tr>

            
            
          </tbody>
        </table>
      </div>

      {/* Edit popup modal */}
      {editPatient && (
        <AddPatientPopup
          show={editPatient}
          handleClose={handleClose}
          editpatientsdetail={patientDetail}
        />
      )}
    </div>
  );
};

PatientInfo.propTypes = {
  patient: PropTypes.object.isRequired,
};

export default PatientInfo;
